import Vue from 'vue'

const state = {
    switch: false,
    dialog: {
        isShow: true,
        width: '800px',
        closeOnModal: false,
        closeOnEscape: false,
        class: "dialo-tip-wrapper-normal"
    },
    view: {
        left: {
            img: {
                src: ""+ process.env.BASE_URL +"static/images/gra-promotion-codetask-getMissionKey.png",
                shit: 'mxw:450px; h:100%;',
            }
        },
        position: {
            describe: {
                shit: 'font-w:500; mxw:266px; lh:normal; absolute; top:172px; right:39px;',
                children: [{
                    shit: 'font:24px; letter-s:1.37px; c:#00b5e2; mb:10px;',
                    txt: Vue.prototype.$t("code-lab/view/dialo-tip-wrapper/observable.js_0")
                },
                {
                    shit: 'c:#272727; font:18px; letter-s:1.03px; lh:1.5;',
                    txt: Vue.prototype.$t("code-lab/view/dialo-tip-wrapper/observable.js_1")
                }]
            },
            control: {
                shit: 'font:16px; font-w:500; letter-s:1.07px; w:190px; absolute; right:77px; bottom:30px;`',
                button: {
                    shit: 'p:0px; w:100%; radius:10px; bgc:#00b5e2!; c:#fff!; border:none; hover:opacity:0.6; active:opacity:1;',
                    span: {
                        shit: 'dis:b; h:45px; lh:45px; font:16px!; font-w:500; letter-s:1.07px; c:#fff;',
                        txt: Vue.prototype.$t("code-lab/view/dialo-tip-wrapper/observable.js_2")
                    }
                },
            }
        }

    }
}

export const store = Vue.observable(state)

export const mutations = {
    switch (payload) {
        store.switch = payload
    },
    'view.left.img.src' (payload) {
        Object.assign(store.view.left.img, { src: payload })
    },
    'view.position.describe.children.0.txt' (payload) {
        Object.assign(store.view.position.describe.children[0], { txt: payload })
    },
    'view.position.describe.children.1.txt' (payload) {
        Object.assign(store.view.position.describe.children[1], { txt: payload })
    },
    'view.position.control.button.span.txt' (payload) {
        Object.assign(store.view.position.control.button.span, { txt: payload })
    },
}
